import React, { useState, useEffect, useMemo } from 'react';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { deloSledilec } from '../lib/deloSledilec'; // [PATCH pregled-dela v2]
import toast from 'react-hot-toast';
import { Download, RotateCcw, RefreshCw } from 'lucide-react';
import { predponaIzSerije } from '../utils/docSmer';  /* [PATCH interne-predpone v1] */
import { smerAplikacije, preberiAplikacijo } from '../aplikacije'; // [PATCH aplikacije-fe v3] smer po aktivni aplikaciji

const fmt = (n: number) => { const x = Number(n || 0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; }; // [PATCH stevilke-locila v1] tisociska pika

export function PrenosiPage() {
  const { selectedCompany } = useAuthStore();
  const companyId = selectedCompany?.id || '';
  const [stanje, setStanje] = useState<'za_prenos' | 'preneseno'>('za_prenos');
  const [vrstice, setVrstice] = useState<any[]>([]);
  const [izbrani, setIzbrani] = useState<Set<string>>(new Set());
  const [nalagam, setNalagam] = useState(false);
  const [delam, setDelam] = useState(false);
  const [program, setProgram] = useState('vasco');
  const [tip, setTip] = useState<'prejeti_racun'|'izdani_racun'>(smerAplikacije(preberiAplikacijo()) || 'prejeti_racun'); // [PATCH vod-izdani-ui v1] // [PATCH aplikacije-fe v3] smer iz aplikacije
  useEffect(() => { const s = smerAplikacije(preberiAplikacijo()); if (s && s !== tip) setTip(s); }, []); // [PATCH aplikacije-fe v3] ob menjavi aplikacije (isti mount)
  const [priloge, setPriloge] = useState(true); // [PATCH vod-priloge v1] VOD: vgradi PDF (Sken)
  const [odSt, setOdSt] = useState('');
  const [doSt, setDoSt] = useState('');
  const [odDat, setOdDat] = useState('');
  const [doDat, setDoDat] = useState('');
  const [q, setQ] = useState('');

  const naloziSeznam = () => {
    if (!companyId) return;
    setNalagam(true); setIzbrani(new Set());
    api.get(`/izvoz/${companyId}/seznam?stanje=${stanje}&tip=${tip}`) // [PATCH vod-izdani-ui v1]
      .then(r => setVrstice(r.data || []))
      .catch(() => setVrstice([]))
      .finally(() => setNalagam(false));
  };
  useEffect(naloziSeznam, [companyId, stanje, tip]); // [PATCH vod-izdani-ui v1]
  /* [PATCH pregled-dela v2] merjenje faze 'prenos' */
  useEffect(()=>{
    if(!companyId) return;
    deloSledilec.zacni('prenos', {companyId, docType: tip});
    return ()=>{ deloSledilec.koncaj('zapri'); };
  },[companyId, tip]);

  // [PATCH vod-izvoz-ui v1] privzeti program iz profila podjetja (isti vzorec kot DokumentiPage).
  // 'pantheon' -> 'opal': VOD = skupni standard Vasco-Opal-Datalab (Datalab = Pantheon).
  useEffect(() => {
    if (!companyId) return;
    api.get(`/profil/${companyId}`)
      .then(r => { const p = r.data?.izvoz_program; setProgram(p === 'opal' || p === 'pantheon' ? 'opal' : 'vasco');
                   /* [PATCH prenos-pdf-nastavitev v1] privzetek kljukice iz nastavitev podjetja */
                   setPriloge(r.data?.prenos_prilozi_pdf !== false); })
      .catch(() => {});
  }, [companyId]);

  const filtrirane = useMemo(() => vrstice.filter(d => {
    /* [PATCH vod-interna-izdani v1] filter Interna st. od-do velja za obe smeri (izdani imajo zdaj interno stevilko) */
    if (odSt && (d.interno_st == null || Number(d.interno_st) < Number(odSt))) return false;
    if (doSt && (d.interno_st == null || Number(d.interno_st) > Number(doSt))) return false;
    if (odDat && (d.datum || '') < odDat) return false;
    if (doDat && (d.datum || '') > doDat) return false;
    if (q) { const s = ((d.doc_number || '') + ' ' + (d.partner || '')).toLowerCase(); if (!s.includes(q.toLowerCase())) return false; }
    return true;
  }), [vrstice, odSt, doSt, odDat, doDat, q, tip]); // [PATCH vod-izdani-ui v1]

  const preklopi = (id: string) => setIzbrani(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const vsi = filtrirane.length > 0 && filtrirane.every(d => izbrani.has(d.id));
  const oznaciVse = () => setIzbrani(vsi ? new Set() : new Set(filtrirane.map(d => d.id)));

  const prenesi = async () => {
    const ids = Array.from(izbrani);
    if (!ids.length) { toast.error('Izberite vsaj en dokument'); return; }
    setDelam(true);
    try {
      const _prog = program; // [PATCH kn21-izdani v1] D1/D2: program iz profila velja za OBE smeri (prej: izdani vedno VOD)
      const body: any = { doc_ids: ids, priloge }; // [PATCH vod-priloge v1] + [PATCH kn21-priloge v1] oba programa
      const r = await api.post(`/izvoz/${_prog}/${companyId}`, body, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      // [PATCH vod-izvoz-ui v1] ime datoteke iz Content-Disposition (backend ga pošlje), fallback po programu
      const cd = String(r.headers?.['content-disposition'] || '');
      const m = cd.match(/filename="?([^";]+)"?/);
      a.href = url; a.download = m ? m[1] : `${program === 'opal' ? 'VOD' : 'KN21'}_${new Date().toISOString().slice(0, 10)}.xml`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Preneseno: ${ids.length} dokumentov`);
      naloziSeznam();
    } catch (e: any) {
      let msg = 'Napaka pri prenosu';
      // [PATCH vod-izvoz-ui v1] detail je lahko objekt {sporocilo, preskoceni[]} (VOD 422)
      try {
        const d = JSON.parse(await e?.response?.data?.text())?.detail;
        if (typeof d === 'string') msg = d;
        else if (d?.sporocilo) {
          msg = d.sporocilo;
          if (Array.isArray(d.preskoceni) && d.preskoceni.length)
            msg += ` — ${d.preskoceni[0].dokument}: ${d.preskoceni[0].razlog}` + (d.preskoceni.length > 1 ? ` (+${d.preskoceni.length - 1})` : '');
        }
      } catch {}
      toast.error(msg);
    } finally { setDelam(false); }
  };

  const odznaci = async () => {
    const ids = Array.from(izbrani);
    if (!ids.length) { toast.error('Izberite vsaj en dokument'); return; }
    if (!window.confirm(`Odznačiti ${ids.length} dokumentov za ponovni prenos?`)) return;
    setDelam(true);
    try {
      const r = await api.post(`/izvoz/${companyId}/odznaci`, { doc_ids: ids });
      toast.success(`Odznačeno: ${r.data?.odznaceni ?? ids.length}`);
      naloziSeznam();
    } catch { toast.error('Napaka pri odznačevanju'); }
    finally { setDelam(false); }
  };

  const skupaj = filtrirane.reduce((s, d) => s + Number(d.znesek || 0), 0);
  const tabBtn = (aktiven: boolean) => `px-4 py-2 rounded-xl text-sm font-medium border ${aktiven ? 'bg-blue-600 text-white border-blue-600' : 'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700'}`;
  const inp = 'px-2 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm';

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Prenosi</h1>
        <div className="flex items-center gap-2">
          <select value={program} disabled onChange={e => setProgram(e.target.value)} className={inp} title="Program iz nastavitev podjetja (Nastavitve → Računovodski program)">{/* [PATCH kn21-izdani v1] D1: bralni */}
            <option value="vasco">Vasco (KN-21)</option>
            <option value="opal">Opal / Pantheon — VOD</option>{/* [PATCH vod-izvoz-ui v1] */}
          </select>
          {true && (/* [PATCH kn21-priloge v1] PDF priloga pri VOD (Sken) in KN-21 (Priloga) */
            <label className="flex items-center gap-1.5 text-sm text-gray-600 dark:text-gray-300 px-2 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 cursor-pointer" title="V XML vgradi PDF vsakega dokumenta (VOD: Sken, KN-21: Priloga)">
              <input type="checkbox" checked={priloge} onChange={e => setPriloge(e.target.checked)} /> Priloži PDF
            </label>
          )}{/* [PATCH vod-priloge v1] */}
          <button onClick={naloziSeznam} className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-500" title="Osveži"><RefreshCw className="w-4 h-4" /></button>
        </div>
      </div>

      <div className="flex gap-2">
        <span className={tabBtn(true)} title="Smer določa izbrana aplikacija">{tip === 'izdani_racun' ? 'Izdani' : 'Prejeti'}</span>{/* [PATCH aplikacije-fe v3] prej gumba Prejeti/Izdani */}
        <span className="w-px self-stretch bg-gray-200 dark:bg-gray-700 mx-1"/>
        <button onClick={() => setStanje('za_prenos')} className={tabBtn(stanje === 'za_prenos')}>Za prenos</button>
        <button onClick={() => setStanje('preneseno')} className={tabBtn(stanje === 'preneseno')}>Preneseno</button>
      </div>

      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-4 space-y-3">
        <div className="flex flex-wrap items-end gap-3">
          <div><label className="block text-xs text-gray-500 mb-1">Interna št. od</label><input value={odSt} onChange={e => setOdSt(e.target.value)} type="number" className={`w-24 ${inp}`} /></div>
          <div><label className="block text-xs text-gray-500 mb-1">do</label><input value={doSt} onChange={e => setDoSt(e.target.value)} type="number" className={`w-24 ${inp}`} /></div>
          <div><label className="block text-xs text-gray-500 mb-1">Datum od</label><input value={odDat} onChange={e => setOdDat(e.target.value)} type="date" className={inp} /></div>
          <div><label className="block text-xs text-gray-500 mb-1">do</label><input value={doDat} onChange={e => setDoDat(e.target.value)} type="date" className={inp} /></div>
          <div className="flex-1 min-w-[160px]"><label className="block text-xs text-gray-500 mb-1">Iskanje (št./partner)</label><input value={q} onChange={e => setQ(e.target.value)} className={`w-full ${inp}`} /></div>
        </div>

        <div className="flex items-center justify-between flex-wrap gap-2">
          <span className="text-sm text-gray-500">{filtrirane.length} dok. · skupaj {fmt(skupaj)} € · izbrano {izbrani.size}</span>
          {stanje === 'za_prenos' ? (
            <button onClick={prenesi} disabled={delam || !izbrani.size} className="flex items-center gap-2 px-4 py-2 rounded-xl bg-blue-600 text-white text-sm font-medium disabled:opacity-50"><Download className="w-4 h-4" /> Prenesi izbrane</button>
          ) : (
            <button onClick={odznaci} disabled={delam || !izbrani.size} className="flex items-center gap-2 px-4 py-2 rounded-xl bg-amber-600 text-white text-sm font-medium disabled:opacity-50"><RotateCcw className="w-4 h-4" /> Odznači izbrane</button>
          )}
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-gray-500 border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="px-2 py-2 text-left"><input type="checkbox" checked={vsi} onChange={oznaciVse} /></th>
                <th className="px-2 py-2 text-left">Int. št.</th>
                <th className="px-2 py-2 text-left">Št. računa</th>
                <th className="px-2 py-2 text-left">Partner</th>
                <th className="px-2 py-2 text-left">Datum</th>
                <th className="px-2 py-2 text-right">Znesek</th>
                {stanje === 'preneseno' && <th className="px-2 py-2 text-left">Preneseno</th>}
              </tr>
            </thead>
            <tbody>
              {nalagam ? (
                <tr><td colSpan={7} className="px-2 py-6 text-center text-gray-400">Nalagam…</td></tr>
              ) : filtrirane.length === 0 ? (
                <tr><td colSpan={7} className="px-2 py-6 text-center text-gray-400">Ni dokumentov</td></tr>
              ) : filtrirane.map(d => (
                <tr key={d.id} className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer" onClick={() => preklopi(d.id)}>
                  <td className="px-2 py-1.5"><input type="checkbox" checked={izbrani.has(d.id)} onChange={() => preklopi(d.id)} onClick={e => e.stopPropagation()} /></td>
                  {/* [PATCH prenosi-brez-leta v1] samo interna stevilka; leto je ze v njej (YY+zaporedna) */}
                  {/* [PATCH interne-predpone v1] predpona iz serije ('D2026' -> 'D'); oblika ostane brez /leta */}
                  {/* [PATCH izdani-interna-originalna v1] interna oznaka ima prednost */}
                  <td className="px-2 py-1.5">{d.interna_oznaka ? d.interna_oznaka : (d.interno_st == null ? '—' : `${predponaIzSerije(d.interno_st_serija)}${d.interno_st}`)}</td>
                  <td className="px-2 py-1.5 font-mono text-xs">{d.doc_number || '—'}</td>
                  <td className="px-2 py-1.5">{d.partner || '—'}</td>
                  <td className="px-2 py-1.5">{d.datum || '—'}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{fmt(d.znesek)}</td>
                  {stanje === 'preneseno' && <td className="px-2 py-1.5 text-xs text-gray-500">{(d.exported_at || '').slice(0, 16).replace('T', ' ')} · {d.export_format || ''}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
